/** @internal */
export const COMPONENT_NAME = 'InformationOverlay';
